export enum ApiState {
    NOT_STARTED = 'NOT_STARTED',
    PENDING = 'PENDING',
    REJECTED = 'REJECTED',
    FULFILLED = 'FULFILLED',
}
